export function useConfirm() {
  const state = useState("confirm", () => ({
    open: false,
    title: "",
    message: "",
    confirmText: "Так",
    cancelText: "Скасувати",
    _resolve: null,
  }));

  const confirm = (opts = {}) =>
    new Promise((resolve) => {
      state.value = {
        open: true,
        title: opts.title || "Підтвердити дію",
        message: opts.message || "",
        confirmText: opts.confirmText || "Так",
        cancelText: opts.cancelText || "Скасувати",
        _resolve: resolve,
      };
    });

  const approve = () => {
    const res = state.value._resolve;
    state.value.open = false;
    state.value._resolve = null;
    res && res(true);
  };
  const cancel = () => {
    const res = state.value._resolve;
    state.value.open = false;
    state.value._resolve = null;
    res && res(false);
  };

  return { state, confirm, approve, cancel };
}
